export const constrainScale = (scale: number, minScale: number = 0.2, maxScale: number = 4) => {
    return Math.min(Math.max(minScale, scale), maxScale)
}
